/* eslint-disable @typescript-eslint/no-floating-promises */
import { createSlice } from "@reduxjs/toolkit";
import { RolesEnum, type UserType } from "../manageUsers/manageUsersTypes";
import { getUserInfo, userLogin, userLogout, userRefresh } from "./authActions";
import { message } from "antd";
import { type RootState } from "../../store";

// initialize userToken from local storage
const accessToken =
  localStorage.getItem("accessToken") != null
    ? localStorage.getItem("accessToken")
    : null;

console.log("accessToken from storage", accessToken);

interface InitialStateType {
  loading: boolean;
  userInfo: UserType;
  // accessToken: string | null,
  error: null | string;
  success: boolean;
  canUserEdit: boolean;
}

const userInfo = localStorage.getItem("userInfo");

const initialState: InitialStateType = {
  loading: false,
  userInfo: userInfo != null ? JSON.parse(userInfo) : {},
  // accessToken,
  error: null,
  success: false,
  canUserEdit: false,
};

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // logout: (state) => {
    //   console.log('logout')
    //   localStorage.removeItem('accessToken') // delete token from storage
    //   state.loading = false
    //   state.userInfo = {} as UserType
    //   state.accessToken = null
    //   state.error = null
    // },
    setCredentials: (state, { payload }) => {
      state.userInfo = payload;
    },
  },
  extraReducers: (builder) => {
    // login user
    builder
      .addCase(userLogin.pending, (state: any) => {
        state.loading = true;
        state.error = null;
        console.log("user login pending");
      })
      .addCase(userLogin.fulfilled, (state: any, { payload }: any) => {
        state.loading = false;
        console.log("user login fulfilled");
        // state.userInfo = payload
      })
      .addCase(userLogin.rejected, (state: any, { payload }: any) => {
        console.log("user login rejected");
        state.loading = false;
        state.error = payload;
        message.error("Неправильные данные");
      })
      .addCase(getUserInfo.pending, (state: any) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserInfo.fulfilled, (state: any, { payload }: any) => {
        state.loading = false;
        state.userInfo = payload;
        state.canUserEdit = state.userInfo.role !== RolesEnum.viewer;
        localStorage.setItem("userInfo", JSON.stringify(payload));
      })
      .addCase(getUserInfo.rejected, (state: any, { payload }: any) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(userLogout.fulfilled, (state: any, { payload }: any) => {
        state.loading = false;
        state.userInfo = {};
        state.accessToken = null;
        state.error = null;
        localStorage.removeItem("userInfo");
        // state.userInfo = payload
      })
      .addCase(userLogout.rejected, (state: any, { payload }: any) => {
        state.loading = false;
        state.userInfo = {};
        state.error = payload;
        localStorage.removeItem("userInfo");
      })

      .addCase(userRefresh.rejected, (state: any, { payload }: any) => {
        state.loading = false;
        state.error = payload;
        state.userInfo = {};
      })
      .addCase(userRefresh.fulfilled, (state: any, { payload }: any) => {
        state.loading = false;
      });
  },
});

export const selectCurrentUser = (state: RootState): UserType =>
  state.user.userInfo;

export const selectCanUserEdit = (state: RootState): boolean =>
  state.user.canUserEdit;

export const { setCredentials } = authSlice.actions;

export default authSlice.reducer;
